// ORGANIZATION

export const SEARCH_USER = 'SEARCH_USER'

export const GET_SEARCH_USER = 'SEARCH_USER'
export const UPDATE_SEARCH_USER = 'UPDATE_SEARCH_USER'
export const RESET_SEARCH_USER = 'RESET_SEARCH_USER'
export const MERGE_ORGANIZATIONS = 'MERGE_ORGANIZATIONS'

// MEMBERSHIPS
export const SET_MEMBERSHIPS = 'SET_MEMBERSHIPS'
export const GET_MEMBERSHIPS = 'GET_MEMBERSHIPS'
export const CREATE_MEMBERSHIP = 'CREATE_MEMBERSHIP'
export const DELETE_MEMBERSHIP = 'DELETE_MEMBERSHIP'
export const UPDATE_MEMBERSHIPS = 'UPDATE_MEMBERSHIPS'

// ASSIGNMENTS
export const GET_MY_ASSIGNMENTS = 'GET_MY_ASSIGNMENTS'
export const GET_MY_ASSIGNMENTS_PAGED = 'GET_MY_ASSIGNMENTS_PAGED'
export const SET_MY_ASSIGNMENTS = 'SET_MY_ASSIGNMENTS'
export const SET_MY_ASSIGNMENTS_PAGED = 'SET_MY_ASSIGNMENTS_PAGED'
export const GET_ASSIGNMENT = 'GET_ASSIGNMENT'
export const ADD_CASE_FORM_ASSIGNMENT = 'ADD_CASE_FORM_ASSIGNMENT'
export const DELETE_CASE_FORM_ASSIGNMENT = 'DELETE_CASE_FORM_ASSIGNMENT'
export const FETCHING_ASSIGNMENTS = 'FETCHING_ASSIGNMENTS'

// CASES
export const GET_CASES = 'GET_CASES'
export const GET_CASE = 'GET_CASE'
export const SET_CASES = 'SET_CASES'
export const SET_CASE = 'SET_CASE'
export const ADD_CASE = 'ADD_CASE'
export const UPDATE_CASE = 'UPDATE_CASE'
export const FETCHING_CASES = 'FETCHING_CASES'
export const CREATE_CASE_NOTE = 'CREATE_CASE_NOTE'
export const UPDATE_CASE_NOTE = 'UPDATE_CASE_NOTE'
export const DELETE_CASE_NOTE = 'DELETE_CASE_NOTE'
export const ADD_CASE_NOTE = 'ADD_CASE_NOTE'

// CASE VIEWS
export const GET_CASE_TOOLBOX_COUNTS = 'GET_CASE_TOOLBOX_COUNTS'
export const SET_CASE_TOOLBOX_COUNTS = 'SET_CASE_TOOLBOX_COUNTS'
export const CLEAR_CASE_TOOLBOX_COUNTS = 'CLEAR_CASE_TOOLBOX_COUNTS'

export const GET_CASE_PREFERENCES = 'GET_CASE_PREFERENCES'
export const SET_CASE_PREFERENCES = 'SET_CASE_PREFERENCES'

// PATIENTS
export const UPDATE_PATIENT = 'UPDATE_PATIENT'

// TRIALS
export const SET_TRIALS = 'SET_TRIALS'
export const GET_TRIAL = 'GET_TRIAL'
export const SET_TRIAL = 'SET_TRIAL'
export const GET_TRIAL_IDENTIFICATIONS = 'GET_TRIAL_IDENTIFICATIONS'
export const SET_TRIAL_IDENTIFICATIONS = 'SET_TRIAL_IDENTIFICATIONS'
export const ADD_TRIAL_IDENTIFICATION_STATUS = 'ADD_TRIAL_IDENTIFICATION_STATUS'
export const SET_IDENTIFIED_TRIAL_ELIGIBILITY_DETAILS = 'SET_IDENTIFIED_TRIAL_ELIGIBILITY_DETAILS'
export const FETCHING_TRIALS = 'FETCHING_TRIALS'
export const ADD_PATIENT_ELIGIBILITY_NOTE = 'ADD_PATIENT_ELIGIBILITY_NOTE'
export const UPDATE_ORG_TRIAL = 'UPDATE_ORG_TRIAL'
export const SAVE_PATIENT_ELIGIBILITY_VERIFICATION = 'SAVE_PATIENT_ELIGIBILITY_VERIFICATION'

// SLIDES
export const SET_SLIDES = 'SET_SLIDES'
export const GET_SLIDES = 'GET_SLIDES'
export const GET_MY_SLIDES_PAGED = 'GET_MY_SLIDES_PAGED'
export const GET_SLIDE = 'GET_SLIDE'
export const ADD_SLIDE = 'ADD_SLIDE'
export const POLL_SLIDE = 'POLL_SLIDE'
export const SET_SELECTED_SLIDE = 'SET_SELECTED_SLIDE'
export const MERGE_SLIDES = 'MERGE_SLIDES'
export const EDIT_SLIDE = 'EDIT_SLIDE'
export const UPDATE_SLIDE = 'UPDATE_SLIDE'
export const DELETE_SLIDE = 'DELETE_SLIDE'
export const DOWNLOAD_SLIDE = 'DOWNLOAD_SLIDE'
export const FETCHING_SLIDES = 'FETCHING_SLIDES'

export const GET_SLIDE_THUMBNAIL = 'GET_SLIDE_THUMBNAIL'
export const MERGE_SLIDE_THUMBNAIL = 'MERGE_SLIDE_THUMBNAIL'
export const GET_SLIDE_THUMBNAIL_URL = 'GET_SLIDE_THUMBNAIL_URL'
export const GET_SLIDE_LABEL_URL = 'GET_SLIDE_LABEL_URL'
export const MERGE_SLIDE_LABELS = 'MERGE_SLIDE_LABELS'
export const SET_SLIDE_LABEL_URL = 'SET_SLIDE_LABEL_URL'
export const SET_SLIDE_PAGE_INFO = 'SET_SLIDE_PAGE_INFO'

export const DEPLOY_SLIDE = 'DEPLOY_SLIDE'
export const ADD_SLIDE_DATA = 'ADD_SLIDE_DATA'

// CASE SLIDES
export const ADD_CASE_SLIDE = 'ADD_CASE_SLIDE'
export const GET_CASE_SLIDES = 'GET_CASE_SLIDES'
export const SET_CASE_SLIDES = 'SET_CASE_SLIDES'
export const REMOVE_CASE_SLIDE = 'REMOVE_CASE_SLIDE'
export const MERGE_CASE_SLIDES = 'MERGE_CASE_SLIDES'

// DOCUMENTS
export const ADD_DOCUMENT = 'ADD_DOCUMENT'
export const GET_DOCUMENTS = 'GET_DOCUMENTS'
export const SET_DOCUMENTS = 'SET_DOCUMENTS'
export const GET_DOCUMENT = 'GET_DOCUMENT'
export const SET_DOCUMENT = 'SET_DOCUMENT'
export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT'
export const REMOVE_DOCUMENT = 'REMOVE_DOCUMENT'
export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT'
export const DOWNLOAD_DOCUMENT = 'DOWNLOAD_DOCUMENT'
export const GET_DOCUMENT_URL = 'GET_DOCUMENT_URL'
export const GET_DOCUMENT_URLS = 'GET_DOCUMENT_URLS'

export const SET_DOCUMENT_TYPES = 'SET_DOCUMENT_TYPES'
export const GET_DOCUMENT_TYPES = 'GET_DOCUMENT_TYPES'
export const MERGE_DOCUMENT_TYPES = 'MERGE_DOCUMENT_TYPES'

// CASE DOCUMENTS
export const ADD_CASE_DOCUMENT = 'ADD_CASE_DOCUMENT'
export const GET_CASE_DOCUMENTS = 'GET_CASE_DOCUMENTS'
export const SET_CASE_DOCUMENTS = 'SET_CASE_DOCUMENTS'
export const REMOVE_CASE_DOCUMENT = 'REMOVE_CASE_DOCUMENT'

// TAGS
export const GET_TAGS = 'GET_TAGS'
export const ADD_TAG = 'ADD_TAG'
export const MERGE_TAGS = 'MERGE_TAGS'

// CASE TAGS
export const GET_CASE_TAGS = 'GET_CASE_TAGS'
export const ADD_CASE_TAG = 'ADD_CASE_TAG'
export const MERGE_CASE_TAGS = 'MERGE_CASE_TAGS'
export const REMOVE_CASE_TAG = 'REMOVE_CASE_TAG'
export const ADD_TAG_AND_CASE_TAG = 'ADD_TAG_AND_CASE_TAG'

// ANNOTATIONS
export const GET_ANNOTATION_SHAPES = 'GET_ANNOTATION_SHAPES'
export const GET_CASE_ANNOTATION_SHAPES = 'GET_CASE_ANNOTATION_SHAPES'
export const GET_ANNOTATION_SHAPE = 'GET_ANNOTATION_SHAPE'
export const SET_ANNOTATION_SHAPES = 'SET_ANNOTATION_SHAPES'
export const SET_ANNOTATION_THUMBNAIL = 'SET_ANNOTATION_THUMBNAIL'
export const GET_ANNOTATION_THUMBNAIL_URL = 'GET_ANNOTATION_THUMBNAIL_URL'
export const ADD_ANNOTATION_SHAPE = 'ADD_ANNOTATION_SHAPE'
export const REMOVE_ANNOTATION_SHAPE = 'REMOVE_ANNOTATION_SHAPE'
export const UPDATE_ANNOTATION_SHAPE = 'UPDATE_ANNOTATION_SHAPE'
export const SELECT_ANNOTATION = 'SELECT_ANNOTATION'
export const POLL_ANNOTATION = 'POLL_ANNOTATION'
export const ADD_ACTIVE_INFERENCE_ID = 'ADD_ACTIVE_INFERENCE_ID'
export const REMOVE_ACTIVE_INFERENCE_ID = 'REMOVE_ACTIVE_INFERENCE_ID'
export const SET_DRAWING_COLOR = 'SET_DRAWING_COLOR'

// FORMS
export const GET_FORMS = 'GET_FORMS'
export const MERGE_FORMS = 'MERGE_FORMS'

export const GET_CASE_FORMS = 'GET_CASE_FORMS'
export const GET_CASE_FORM = 'GET_CASE_FORM'

export const SET_CASE_FORMS = 'SET_CASE_FORMS'
export const ADD_CASE_FORM = 'ADD_CASE_FORM'
export const ADD_UNASSIGNABLE_CASE_FORM = 'ADD_UNASSIGNABLE_CASE_FORM'
export const ADD_UNASSIGNABLE_CASE_FORM_RESPONSE = 'ADD_UNASSIGNABLE_CASE_FORM_RESPONSE'
export const GET_UNASSIGNABLE_FORM_RESPONSE = 'GET_UNASSIGNABLE_FORM_RESPONSE'
export const SET_UNASSIGNABLE_FORM_RESPONSES = 'SET_UNASSIGNABLE_FORM_RESPONSES'
export const ADD_UNASSIGNABLE_FORM_RESPONSE = 'ADD_UNASSIGNABLE_FORM_RESPONSE'

export const ADD_CASE_SLIDE_FORM = 'ADD_CASE_SLIDE_FORM'
export const DELETE_CASE_FORM = 'DELETE_CASE_FORM'
export const DELETE_CASE_SLIDE_FORM = 'DELETE_CASE_SLIDE_FORM'

export const DOWNLOAD_CASE_FORM = 'DOWNLOAD_CASE_FORM'

export const GET_CASE_SLIDE_FORMS = 'GET_CASE_SLIDE_FORMS'
export const SET_CASE_SLIDE_FORMS = 'SET_CASE_SLIDE_FORMS'

export const SET_CASE_ASSIGNMENTS = 'SET_CASE_ASSIGNMENTS'
export const ADD_CASE_ASSIGNMENT = 'ADD_CASE_ASSIGNMENT'
export const GET_ASSIGNMENT_RESPONSE = 'GET_ASSIGNMENT_RESPONSE'
export const SET_ASSIGNMENT_RESPONSES = 'SET_ASSIGNMENT_RESPONSES'
export const ADD_ASSIGNMENT_RESPONSE = 'ADD_ASSIGNMENT_RESPONSE'

export const GET_FIELD_OPTIONS = 'GET_FIELD_OPTIONS'
export const SET_FIELD_OPTIONS = 'SET_FIELD_OPTIONS'
export const GET_FIELD_OPTION_ALIASES = 'GET_FIELD_OPTION_ALIASES'
export const SET_FIELD_OPTION_ALIASES = 'SET_FIELD_OPTION_ALIASES'

// STAIN TYPES
export const MERGE_STAIN_TYPES = 'MERGE_STAIN_TYPES'
export const GET_STAIN_TYPES = 'GET_STAIN_TYPES'

// ANATOMIC SITES
export const MERGE_ANATOMIC_SITES = 'MERGE_ANATOMIC_SITES'
export const GET_ANATOMIC_SITES = 'GET_ANATOMIC_SITES'

// LAYOUT
export const SET_TOOLBOX_EXPANDED = 'SET_TOOLBOX_EXPANDED'
export const SET_TOOLBOX_EXPANDED_CASE = 'SET_TOOLBOX_EXPANDED_CASE'
export const SET_TOOLBOX_EXPANDED_SLIDE = 'SET_TOOLBOX_EXPANDED_SLIDE'

// APP VERSION
export const GET_API_VERSION = 'GET_API_VERSION'
export const MERGE_API_VERSION = 'MERGE_API_VERSION'

// UPLOAD MUTATIONS
export const MERGE_FILE_UPLOADS = 'MERGE_FILE_UPLOADS'
export const ADD_UPLOAD = 'ADD_UPLOAD'
export const START_UPLOAD = 'START_UPLOAD'
export const REMOVE_UPLOAD = 'REMOVE_UPLOAD'
export const SET_UPLOAD_STATUS = 'SET_UPLOAD_STATUS'
export const UPDATE_UPLOAD_PROGRESS = 'UPDATE_UPLOAD_PROGRESS'
export const SET_CLIENT_UPLOAD_CONFIG = 'SET_CLIENT_UPLOAD_CONFIG'

// UPLOAD ACTIONS
export const CREATE_FILE_UPLOAD = 'CREATE_FILE_UPLOAD'
export const UPLOAD_FILE = 'UPLOAD_FILE'
export const PAUSE_UPLOAD = 'PAUSE_UPLOAD'
export const CANCEL_UPLOAD = 'CANCEL_UPLOAD'
export const RESUME_UPLOAD = 'RESUME_UPLOAD'
export const PUT_FILE_UPLOAD = 'PUT_FILE_UPLOAD'
export const GET_CLIENT_UPLOAD_CONFIG = 'GET_CLIENT_UPLOAD_CONFIG'
export const MERGE_FILE_OBJECTS = 'MERGE_FILE_OBJECTS'
export const SET_FILE_OBJECT_URL = 'SET_FILE_OBJECT_URL'

// FILTER MUTATIONS
export const ADD_FILTER = 'ADD_FILTER'
export const REMOVE_SINGLE_FILTER = 'REMOVE_SINGLE_FILTER'
export const ADD_TAG_FILTER = 'ADD_TAG_FILTER'
export const REMOVE_SINGLE_TAG_FILTER = 'REMOVE_SINGLE_TAG_FILTER'
export const CLEAR_FILTER = 'CLEAR_FILTER'
export const EXCLUDE_CASE_SLIDES_FILTER = 'EXCLUDE_CASE_SLIDES_FILTER'

// TOOLBOX
export const SET_SELECTED_ANNOTATION = 'SET_SELECTED_ANNOTATION'
export const SET_SELECTED_ASSIGNMENT = 'SET_SELECTED_ASSIGNMENT'

// PRESENTATIONS
export const GET_PRESENTATIONS = 'GET_PRESENTATIONS'
export const GET_PRESENTATION_CONTENT = 'GET_PRESENTATION_CONTENT'
export const GET_PRESENTATION = 'GET_PRESENTATION'
export const SET_PRESENTATIONS = 'SET_PRESENTATIONS'
export const ADD_PRESENTATION = 'ADD_PRESENTATION'
export const UPDATE_PRESENTATION = 'UPDATE_PRESENTATION'
export const DELETE_PRESENTATION = 'DELETE_PRESENTATION'
export const GET_PRESENTATION_CASE_SLIDES = 'GET_PRESENTATION_CASE_SLIDES'
export const SET_PRESENTATION_CASE_SLIDES = 'SET_PRESENTATION_CASE_SLIDES'
export const SET_PRESENTATION_CASE_DOCUMENTS = 'SET_PRESENTATION_CASE_DOCUMENTS'
export const MERGE_PRESENTATION_CASES = 'MERGE_PRESENTATION_CASES'
export const MERGE_PRESENTATION = 'MERGE_PRESENTATION'
export const SET_PRESENTATION_CASES = 'SET_PRESENTATION_CASES'
export const SET_PRESENTATION_CASE_TAGS = 'SET_PRESENTATION_CASE_TAGS'
export const GET_CASES_AGGREGATE_COUNT = 'GET_CASES_AGGREGATE_COUNT'
export const SET_CASES_AGGREGATE_COUNT = 'SET_CASES_AGGREGATE_COUNT'
export const SET_CASE_PRESENTATION_DOCUMENTS = 'SET_CASE_PRESENTATION_DOCUMENTS'
export const SET_SELECTED_PRESENTATION_CONTENT = 'SET_SELECTED_PRESENTATION_CONTENT'
export const SET_PRESENTATION_TRIAL_IDS = 'SET_PRESENTATION_TRIAL_IDS'
export const ADD_PRESENTATION_PREPARER = 'ADD_PRESENTATION_PREPARER'
export const DELETE_PRESENTATION_PREPARER = 'DELETE_PRESENTATION_PREPARER'
export const SET_PRESENTATION_PREPARERS = 'SET_PRESENTATION_PREPARERS'

// BIOMARKERS
export const GET_BIOMARKERS = 'GET_BIOMARKERS'
export const GET_BIOMARKER_METHODS = 'GET_BIOMARKER_METHODS'
export const GET_BIOMARKER_METHOD_RESULTS = 'GET_BIOMARKER_METHOD_RESULTS'
export const SET_BIOMARKER_TEST_RESULTS = 'SET_BIOMARKER_TEST_RESULTS'
export const CLEAR_BIOMARKER_TEST_RESULTS = 'CLEAR_BIOMARKER_TEST_RESULTS'
export const SET_BIOMARKER_DATA = 'SET_BIOMARKER_DATA'

// DIAGNOSES
export const GET_DIAGNOSES = 'GET_DIAGNOSES'
export const SET_DIAGNOSES = 'SET_DIAGNOSES'

// DEMOGRAPHICS
export const CREATE_PATIENT_DEMOGRAPHICS = 'CREATE_PATIENT_DEMOGRAPHICS'
export const UPDATE_PATIENT_DEMOGRAPHICS = 'UPDATE_PATIENT_DEMOGRAPHICS'
export const DELETE_PATIENT_DEMOGRAPHICS = 'DELETE_PATIENT_DEMOGRAPHICS'
export const GET_PATIENT_DEMOGRAPHICS = 'GET_PATIENT_DEMOGRAPHICS'
export const SET_PATIENT_DEMOGRAPHICS = 'SET_PATIENT_DEMOGRAPHICS'
export const GET_DEMOGRAPHICS = 'GET_DEMOGRAPHICS'
export const SET_DEMOGRAPHICS = 'SET_DEMOGRAPHICS'

// NOTIFICATIONS
export const GET_UNREAD_COUNTS = 'GET_UNREAD_COUNTS'
export const SET_UNREAD_COUNTS = 'SET_UNREAD_COUNTS'
